import TWEEN from 'tween';
import { Vector3 } from 'three';

let positionTween = null;
let targetTween = null;

function stopActiveTweens() {
  if (positionTween) {
    positionTween.stop();
    positionTween = null;
  }
  if (targetTween) {
    targetTween.stop();
    targetTween = null;
  }
}

function tweenDuration(camera, controls, position, target) {
  const posDist = position
    ? camera.position.distanceTo(new Vector3(position.x, position.y, position.z))
    : 0;
  const targetDist =
    target && controls?.target
      ? controls.target.distanceTo(new Vector3(target.x, target.y, target.z))
      : 0;
  const travel = Math.max(posDist, targetDist);
  return Math.min(2600, Math.max(1000, travel * 0.08));
}

export function animateCameraTo({ camera, controls, position, target, duration }) {
  if (!camera) return;

  stopActiveTweens();

  const ms = duration ?? tweenDuration(camera, controls, position, target);
  const easing = TWEEN.Easing.Cubic.InOut;
  const syncControls = () => controls?.update?.();

  if (position) {
    positionTween = new TWEEN.Tween(camera.position)
      .to({ x: position.x, y: position.y, z: position.z }, ms)
      .easing(easing)
      .onUpdate(syncControls)
      .onComplete(() => {
        positionTween = null;
        syncControls();
      })
      .start();
  }

  if (target && controls) {
    targetTween = new TWEEN.Tween(controls.target)
      .to({ x: target.x, y: target.y, z: target.z }, ms)
      .easing(easing)
      .onUpdate(syncControls)
      .onComplete(() => {
        targetTween = null;
        syncControls();
      })
      .start();
  }
}
